import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextBadgeProps = Pick<
  TypographyProps,
  'label' | 'color' | 'uppercase' | 'ellipsis'
>;

export const TextBadge = ({
  label,
  color = 'text-ds-natural',
  uppercase,
  ellipsis,
}: TextBadgeProps) => (
  <Typography
    uppercase={uppercase}
    color={color}
    ellipsis={ellipsis}
    label={label}
    tagName="span"
    fontSize="text-ds-100"
    lineHeight="leading-ds-200"
    fontWeight="font-ds-normal"
    letterSpacing="tracking-ds-tight"
  />
);
